import { useState } from 'react';
import { Spinner } from 'reactstrap';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Link } from '@s20/components/common/Link';
import { appendTimeZone } from '@s20/common/util/date';
import { httpClient } from '@s20/services/httpClient';
import { FormCheckbox } from '../common/forms/FormElements';
import { Can } from '../Can';
import { ApiRoutes, AppNavPaths } from '../Common';

export const EquipmentLogModalBody = ({ timesheetId, ...details }) => {
    const [showOnlyJobAssigned, setShowOnlyJobAssigned] = useState(false);

    const { data: result, isLoading } = useQuery({
        queryKey: ['timesheetEquipmentAudit', timesheetId],
        queryFn: () => httpClient.js(ApiRoutes.timesheet.equipmentAudit(timesheetId)),
    });

    if (isLoading) {
        return (
            <div className="text-center p-3">
                <Spinner color="primary" />
            </div>
        );
    }

    const filteredLog = showOnlyJobAssigned
        ? result.filter((log) => log.assignedToJob)
        : result;

    return (
        <div className="equipment-audit table-responsive-md">
            <FormCheckbox
                id="showOnlyJobAssignedEquipmentModal"
                name="showOnlyJobAssignedEquipmentModal"
                labelText="Only Show Job-Assigned Equipment"
                checked={showOnlyJobAssigned}
                onChange={(e) => setShowOnlyJobAssigned(e.target.checked)}
            />

            <table className="table table-bordered table-striped timesheet-details-table">
                <thead className="text-muted">
                    <tr>
                        <th className="auditVehicle">Time</th>
                        <th className="auditVehicle">Equipment</th>
                        <th className="auditDriver">Assigned To</th>
                        <th className="auditCreated">Event</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredLog.length === 0 ? (
                        <tr>
                            <td
                                colSpan="4"
                                className="text-center"
                            >
                                No logs found.
                            </td>
                        </tr>
                    ) : filteredLog.map((logEntry, index) => {
                        const time = moment(logEntry.createdOn).format('MMM DD, h:mm a');
                        const arrivalTime = appendTimeZone(time, details.jobStartTimeOffset, details.timeZone);

                        return (
                            <tr key={index}>
                                <td>{arrivalTime}</td>
                                <td>
                                    {logEntry.equipmentIdentifier}

                                    <Can
                                        I="view"
                                        a="equipment"
                                    >
                                        <Link
                                            to={`${AppNavPaths.Equipment}?eId=${logEntry.equipmentId}`}
                                            target="_blank"
                                            className="ml-1"
                                        >
                                            <FontAwesomeIcon
                                                icon={faArrowUpRightFromSquare}
                                                size="sm"
                                            />
                                        </Link>
                                    </Can>
                                </td>
                                <td>
                                    {/* {logEntry.employeeName == true ? ( */}

                                    {logEntry.employeeName ? (
                                        <>
                                            {logEntry.employeeName}

                                            <Can
                                                I="view"
                                                a="employee"
                                            >
                                                <Link
                                                    to={`${AppNavPaths.Employee}/${logEntry.employeeId}`}
                                                    target="_blank"
                                                    className="ml-1"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faArrowUpRightFromSquare}
                                                        size="sm"
                                                    />
                                                </Link>
                                            </Can>
                                        </>
                                    ) :
                                        <>-</>
                                    }

                                </td>
                                <td>{logEntry.message}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};